// ── Profile Completion & Onboarding Steps ─────────────────────────────────
import { getEffectiveTranslations } from './i18n';

function t(lang, key) {
  return getEffectiveTranslations(lang||'en')[key] || key;
}

export function getCompletionSteps(lang) {
  return [
    { id:'photo',     label:t(lang,'completion.add_photo'),    points:20, check:u=>(u.photos||[]).length>0,                          cta:t(lang,'completion.cta_photo'),    tab:'profile' },
    { id:'bio',       label:t(lang,'completion.write_bio'),    points:15, check:u=>u.bio&&u.bio.length>20,                           cta:t(lang,'completion.cta_bio'),      tab:'about'   },
    { id:'prompt',    label:t(lang,'completion.add_prompt'),   points:15, check:u=>u.prompt1?.a||u.prompt2?.a,                       cta:t(lang,'completion.cta_prompt'),   tab:'about'   },
    { id:'interests', label:t(lang,'completion.add_interests'),points:10, check:u=>(u.interests||[]).length>=3,                      cta:t(lang,'completion.cta_interests'),tab:'about'   },
    { id:'quiz',      label:t(lang,'completion.take_quiz'),    points:20, check:u=>u.quiz_answers&&Object.keys(u.quiz_answers).length>5,cta:t(lang,'completion.cta_quiz'),     tab:'settings'},
    { id:'friends',   label:t(lang,'completion.invite_friend'),points:15, check:u=>(u.votes||0)>=1,                                  cta:t(lang,'completion.cta_friends'),  tab:'invite'  },
    { id:'details',   label:t(lang,'completion.fill_basics'),  points:5,  check:u=>u.age&&(u.height||u.education),                   cta:t(lang,'completion.cta_details'),  tab:'about'   },
  ];
}

// Backward-compat export (EN only)
export const COMPLETION_STEPS = getCompletionSteps('en');

export function getCompletionScore(user) {
  const steps = getCompletionSteps('en');
  const earned = steps.filter(s => s.check(user));
  return {
    score:   earned.reduce((sum,s)=>sum+s.points,0),
    max:     100,
    done:    earned.map(s=>s.id),
    pending: steps.filter(s=>!s.check(user)),
    pct:     Math.round(earned.reduce((sum,s)=>sum+s.points,0)),
  };
}

export function getNextStep(user) {
  return getCompletionSteps('en').find(s=>!s.check(user))||null;
}

export function getProfileMilestones(lang) {
  return [
    { pct: 25,  message:getEffectiveTranslations(lang||'en')['completion.m25']  },
    { pct: 50,  message:getEffectiveTranslations(lang||'en')['completion.m50']  },
    { pct: 75,  message:getEffectiveTranslations(lang||'en')['completion.m75']  },
    { pct: 100, message:getEffectiveTranslations(lang||'en')['completion.m100'] },
  ];
}

export const PROFILE_MILESTONES = getProfileMilestones('en');

export function getMilestoneMessage(pct, lang) {
  const milestones = getProfileMilestones(lang);
  const reached = [...milestones].reverse().find(m=>pct>=m.pct);
  return reached?.message||null;
}
